<template>

  <div :data-clip="element.slug" class="thread-clip-wrapper" v-if="element && isLegacy">
    <span class="scroll-anchor" :id="`anchor_${element.slug}`"></span>

    <div class="edit-actions" :class="{'edit-mode-on' : editOn}">
      <div class="actions">
        <router-link class="action" :to="getClipUrl"><global-svg type="link" height="14px"></global-svg></router-link>
        <div v-if="myPaper" class="action" v-on:click="deleteClip()"><global-svg type="delete" height="14px"></global-svg></div>
        <div v-if="myPaper && !paper.public && !editOn" class="action" v-on:click="editMode('switch')"><global-svg type="edited" height="14px"></global-svg></div>
        <div v-if="myPaper && !paper.public &&  editOn" class="action stretch" :class="{'disabled' : !invalidComment}" v-on:click="updateClip(element)">Save Changes</div>
        <div v-if="myPaper && (idx !== 0)" class="action" v-on:click="adjustPlacement(-1)"><global-svg type="chevron-up" height="8px"></global-svg></div>
        <div v-if="myPaper && (idx !== paper.elements.length - 1)" class="action" v-on:click="adjustPlacement(+1)" ><global-svg type="chevron-down" height="8px"></global-svg></div>
      </div>
    </div>
    
    <!-- Heading -->
    <div class="thread-row thread-row-head">
      <h3 v-html="element.name"></h3>
    </div>

    <!-- Quote -->
    <div class="thread-row thread-row-publisher">
      <!-- <div class="thread-left article">
        <div class="article-image">
          <img :src="element.article.image" :alt="element.name"/>
        </div>
        <div class="article-content">
          <h4 v-html="element.article.name"></h4>
          <div class="article-meta">
            <div class="rounded-image">
              <img v-if="element.article.publisher.icon" :src="element.article.publisher.icon" :alt="element.article.publisher.name">
            </div>
            <div class="inner-meta publisher">
              <span>{{ getPublisherName }}</span>
            </div>
            <div class="inner-meta">
              <span>{{ element.article.published | ago }}</span>
            </div>
          </div>
        </div>
      </div> -->

      <div class="thread-mid publisher">
        <div class="section-aside">
          <div class="rounded-image">
            <img v-if="element.article.publisher.icon" :src="element.article.publisher.icon" :alt="element.article.publisher.name">
          </div>
          <div class="section-marker onesub"></div>
        </div>
        <div>
          <div class="publisher-byline">Quoted from an article published by {{ element.article.publisher.name }} {{element.article.published | ago}}</div>
          <div class="thread-paragraph onesub">
            <p v-for="(sentence, i) in element.clips" :key="element.slug + ':mid:' + i" v-html="sentence.text"></p>
          </div>
        </div>
      </div>
    </div>

    <!-- Comment -->
    <div class="thread-row thread-row-author quote">
      <!-- <div class="thread-left profile-card thread-stack-hide">
        <div class="profile">
          <button class="btn btn-meta follower follow">Follow</button>
          <h4>{{paper.author.name}}</h4>
        </div>
        <div class="stats">
          <div><span class="stat">{{paper.author.stats.followers}}</span><span class="label"> followers</span></div>
          <div><span class="stat">{{paper.author.stats.following}}</span><span class="label"> following</span></div>
          <div><span class="stat">{{paper.author.stats.thread_count}}</span><span class="label"> threads</span></div>
        </div>
        <div class="bio">
          <p>{{paper.author.bio}}</p>
        </div>
      </div> -->

      <div class="thread-mid">
        <div class="section-aside">
          <div class="rounded-image">
            <img v-if="paper.author.avatar" :src="paper.author.avatar" :alt="paper.author.name">
          </div>
          <div class="section-marker thread"></div>
        </div>

        <div class="section-mid">
          <!-- <div class="publisher-byline">{{paper.author.name}}</div> -->
          <div class="thread-paragraph" v-if="!editOn">
            <p v-html="element.text"></p>
          </div>
          
          <div v-else class="edit-wrapper">   
            <!-- eslint-disable-next-line vue/no-mutating-props -->    
            <textarea class="input-comment blue" v-model="element.text" onfocus='this.style.height = "";this.style.height = this.scrollHeight + "px"' placeholder="What are you telling people with this quote?..."></textarea>
            <span class="comment-count" :class="{'invalid' : validateCommentCount(element)}">{{ getCommentCount(element) }} / 1000</span>

            <!-- <button class="is-button threads no-arrow" v-if="myPaper && !validateCommentCount(element)" v-on:click="updateClip(element);">
              <global-svg class="icon" type="edited" width="12px" height="15px" color="#FFF"/>
              <span class="text">Save Changes</span>
            </button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- <h3 v-html="element.name"></h3>

    <div class="thread-quote" v-if="element.clips.length > 0">
      <div>
        <p v-for="(sentence, i) in element.clips" :key="element.slug + ':' + i" v-html="sentence.text"></p>
      </div>

      <div class="quoted-article">
        <div class="article-image">
          <img :src="element.article.image" :alt="element.name">
        </div>

        <h4 v-html="element.article.name"></h4>
        
        <div class="article-data">
          <h4 v-html="element.article.name"></h4>
          <div class="quoted-meta">
            <div class="publisher">
              <img v-if="element.article.publisher.icon" :src="element.article.publisher.icon" :alt="element.article.publisher.name">
              <span class="inner-meta">{{ getPublisherName }}</span>
            </div>
            <div class="timestamp">
              <span class="inner-meta">{{ element.article.published | ago }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="thread-comment" v-html="nlToBr(element.text)"></div> -->

  </div>
</template>

<script>
  // import API from "app/axios.js";

  export default {
    data() {
      return {
        editOn: false,
        invalidComment: false
      }
    },
    props: [
      'paper',
      'element',
      'idx',
      'isLegacy'
    ],
    computed: {
      myPaper() {
        return this.$store.getters.screenName && (this.paper?.author?.screen_name == this.$store.getters.screenName)
      },

      getPublisherName() {
        let pub = this.element?.article?.publisher || {};
        return pub.name[0] != '(' ? pub.name : pub.domain.replace(/www\./,'');
      },
      getArticleLink() {
        let sArticle = this.element?.article?.slug;
        let sStory = this.element?.article?.stories[0]?.slug || '-';
        return `/story/${sStory}/${sArticle}/`; 
      },
      getClipUrl() {
        return `/~${this.paper.author.screen_name}/${this.paper.slug}/${this.element.slug}`; 
      },
      // validateSave() {

      // }
    },
    methods: {
      didSelectSocial(type) {
        const payload = {
          platform: type,
          text: this.element.name,
          link: `https://nourished.news/~${this.paper.author.screen_name}/${this.paper.slug}/${this.element.slug}`,
        }
        this.EventBus.$emit('social:share', payload);
      },

      getCommentCount(element) {
        return element.text.length
      },

      validateCommentCount(element) {
        if (element.text.length < 15 || element.text.length > 1000) {
          this.invalidComment = false;
          return true;
        }
        
        this.invalidComment = true;
        return false;
      },

      adjustPlacement(direction) {
        this.$emit('adjustPlacement', {
          idx: this.idx,
          direction: direction
        });
      },

      editMode(bOn) {
        if (bOn === 'switch') {
          this.editOn = !this.editOn;
        } else {
          this.editOn = bOn;
          this.$refs.commentField.focus();
        }
      },

      deleteClip() {
        this.EventBus.$emit('showInboundMessage', {
          code: 'TH001',
          callback: (code) => {
            if (code == 'delete'){
              this.$emit('clipDeleted', this.element.slug);
            }
            if (code == 'cancel'){
              return;
            }
          }
        });
      },

      updateClip(element) {
        this.editOn = false;
        this.$emit('updateClip', {
          name: element.name,
          clip: element.slug,
          text: element.text,
        });
      },
      
      nlToBr(text) {
        return text.split(/[\r\n]+/).map(s => `<p>${s}</p>`).join('');
      },
    },
    mounted() {
      this.$nextTick(function () {
        if (this.$route?.params?.clip == this.element?.slug) {
          // console.log("Scroll: ", document.getElementById(`anchor_${this.element.slug}`));
          document.getElementById(`anchor_${this.element.slug}`)?.scrollIntoView({
            block: 'start', 
            inline: 'nearest',
            behavior: 'smooth',
          });
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
  // @import 'src/assets/scss/weekly.scss';
  @import 'src/assets/scss/__2020_v3.scss';

  textarea {
    position: relative;
    width: 100%;
    resize: vertical;
    min-height: 16em;
    
    // @media(max-width: 670px) {
    //   margin-left: 0em;
    // }

    .mobile & {
      margin-left: 0em;
    }
  }

  .input-name {
    min-height: 6em;
    font-size: 32px;
    line-height: 1.2;
    font-weight: bold;
    margin-left: 0;
    margin-bottom: 10px;

    // @media(max-width: 670px) {
    //   font-size: 28px;
    // }

    .mobile & {
      font-size: 28px;
    }
  }

  .comment-count {
      position: absolute;
      font-weight: bold;
      font-size: 0.75em;
      color: $blue-tone-7;
      right: 0;
      bottom: 40px;
      color: $white-primary;

      &.invalid {
        color: $red-tone-3;
      }
    }

  .comment-text {
    word-break: break-word;
  }

  .edit-wrapper {
    position: relative;
    width: 100%;
    margin-right: 1em;

    // @media(max-width: 670px) {
    //   margin-right: 0em;
    // }

    .mobile & {
      margin-right: 0em;
    }
    
  }

  // ---------------------------------------
  // v3 Thread
  // ---------------------------------------
  @import 'src/assets/scss/__2020_v3.scss';

  .thread-clip-wrapper {
    max-width: 1200px;
    margin: auto;

    &:not(:first-child) {
      margin-top: 2em;
    }

    // for scroll-to
    position: relative;
    .scroll-anchor {
      position: absolute;
      top: -5em;
    }

    .thread-row {

      //JM Hack
      &.thread-row-publisher {
        margin-left: -3em;
      }
      &.thread-row-author {
        margin-left: -3em;
      }


      display: grid;
      // grid-template-columns: 3fr 8fr 3fr;
      grid-template-columns: 1fr;
      // grid-gap: 30px;
      cursor: pointer;
      @include ease_animation;

      h3 {
        @include typo-size-heading;

        .mobile & {
          margin-bottom: 0;
          margin-right: 1em;
        }
      }

      // Columns
      .thread-left {
        transition: opacity .6s;
        cursor: pointer;
        grid-column: 1;
        opacity: 0;
      }

      .thread-left {
        opacity: 0.1;
        
        .is-desktop & {
          margin-right: 0.5em;
        }

        .mobile {
          margin-top: 1em;
        }

        :hover {
          // opacity: 1;
        }
      }

      &:hover {
        .thread-left {
          opacity: 1;
        }
      }

      .thread-mid {
        display: flex;
        grid-column: 1 / span 2;
        padding: 1em 1em 0 1em;
      }

      .thread-right {
        grid-column: 3;
      }

      .thread-stack-hide {
        display: flex;
      }

      // @media(max-width: 885px) {
      //   .thread-left {
      //     grid-row: 2;
      //     grid-column: 1 / span 5;
      //     opacity: 1;
      //     margin-top: 1em;

      //     &:hover {
      //       opacity: 1;
      //     }
      //   }

      //   .thread-mid {
      //     grid-row: 1;
      //     grid-column: 1 / span 14;
      //   }

      //   .thread-right {
      //     grid-row: 2;
      //     grid-column: 1 / span 3;
      //   }

      //   .thread-stack-hide {
      //     display: none;
      //   }
      // }

      // Content
      
      .section-aside {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 12px 0 0;
      }

      .rounded-image {
        width: 20px;
        height: 20px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }

      .section-mid {
        width: 100%;
      }

      .section-marker {
        width: 2px;
        height: 100%;
        margin-top: 1em;

        &.onesub {
          background: $yellow-tone-3;
        }

        &.thread {
          background: $blue-tone-3;
        }
      }

      .publisher-byline {
        @include typo-size-small;
        margin: 0 0 17px 0;
        opacity: 0.3;
      }

      .thread-paragraph {
        p {
          margin: 0;
        }

        p:not(:last-child) {
          margin-bottom: 0.7em;
        }
      }

      .article {
        @include palette-block;
        display: flex;
        flex-direction: column;
        align-self: flex-start;
        padding: 0.5em;

        // @media(max-width: 885px) {
        //   flex-direction: row;

        //   .article-content {
        //     flex: 1;
        //   }
        // }

        .article-image {
          height: 115px;

          // @media(max-width: 885px) {
          //   width: 40px;
          //   height: 40px;
          //   margin-right: 0.5em;
          // }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        h4 {
          @include typo-size-small;
          margin: 0.8em 0;

          // @media(max-width: 885px) {
          //   margin: 0 0 0.5em 0;
          // }
        }

        .article-meta {
          display: flex;
          align-items: center;

          .inner-meta {
            @include typo-size-small;
            padding-bottom: 2px;
          }

          .publisher {
            margin-left: 0.5em;
            margin-right: 1em;
          }
        }
      }

      .profile-card {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        padding-right: 0.7em;

        // @media(max-width: 885px) {
        //   display: none;
        // }

        .profile {
          display: flex;

          .follow {
            margin-right: 1em;
          }
        }

        .stats {
          display: flex;
          margin: 0.5em 0 0.8em 0;

          div {
            margin-left: 1em;
          }

          .stat, .label {
            @include typo-size-small;
          }
        }

        .bio p {
          @include typo-size-body-small;
          text-align: right;
          line-height: 1.2;
        }
      }
    }

  .edit-actions {
      // position: absolute;
      right: 0;
      width: 100%;
      // display: none;
      opacity: 0;
      transition: opacity .6s;
      

      @media(max-width: 670px) {
        top: -30px;
        margin: 0;
        display: flex;
        justify-content: flex-start;
      }

      .actions {
        position: relative;
        position: absolute;
        display: flex;
        flex-direction: column;
        top: -3px;
        right: -65px;
        // hover safety
        padding-left: 20px;
        padding-right: 20px;
        // width: 100%;
      }

      .action {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        border: 1px solid rgba($blue-tone-7, 0.15);
        border-radius: 50%;
        background: $white-secondary;
        .darkmode & {
          background: none;
          border: 1px solid rgba($blue-tone-3, 0.15);
        }
        
        @include transition;
        cursor: pointer;

        &:not(:last-child) {
          margin-right: 0.5em;
          margin-bottom: 0.5em;
        }

        &.stretch {
          width: unset;
          border-radius: 500px;
          padding: 1px 1em 0 1em;
          font-size: 0.9em;
          font-weight: bold;
          color: $blue-tone-3;

          &.disabled {
            color: rgba($blue-tone-7, 0.3);
            cursor: default;
          }
        }

        global-svg {
          padding-top: 2px;
        }

        &:not(.disabled):hover {
          border: 1px solid $blue-tone-3;
        }
      }
    }

    .edit-mode-on {
      display: flex;
      justify-content: flex-start;
      position: relative;
    }

    &:hover .edit-actions,
    .edit-actions:hover {
      // display: flex;
      // justify-content: flex-start;
      position: relative;
      display: block;
      opacity: 1;
    }







    // padding: 2.8em 0 2em 0;

    // .thread-quote {
    //   display: flex;
    //   flex-direction: column;
    //   align-items: flex-start;
    //   border-left: 5px solid $blue-tone-1;
    //   padding-left: 1em;
    //   margin: 1em 0 0 -1.2em;
 
    //   p {
    //     color: $blue-tone-4;

    //     &:not(:last-child) {
    //       margin-bottom: 0.6em;
    //     }
    //   }

    //   .quoted-article {
    //     display: flex;
    //     flex-direction: row;
    //     align-items: center;
    //     background: $neutral-500;
    //     // height: 28px;
    //     // width: 28px;
    //     // margin-left: 2em;
    //     // margin-right: -3em;
    //     margin-top: 1em;
    //     padding: 0.7em;
    //     cursor: pointer;

    //     // &:nth-child(odd) {
    //     //   margin-left: -3em;
    //     //   margin-right: 2em;
    //     // }

    //     .article-data {
    //       display: flex; 
    //     }

    //     .article-image {
    //       width: 28px;
    //       height: 28px;
    //       // margin-bottom: 0.6em;
    //       margin-right: 0.6em;

    //       img {
    //         width: 100%;
    //         height: 100%;
    //         object-fit: cover;
    //       }
    //     }

    //     .quoted-meta {
    //       display: flex;
    //     }
    //   }
    // }
  }

</style>